import React from 'react';

import { events } from 'client/screens/WordpressScreen/events';
import { useT } from 'client/i18n/hooks/useT';
import { StyledWrapper, SignInNavLink, SignUpNavLink } from './styles';
import { clickSignupButton, clickedNavLinkGoogleAnalytics } from '../../events';

export const SignUpLoginNavItems = ({
  pathname = '',
}: {
  pathname: string;
}) => {
  const t = useT();
  const pathnameLowerCase = pathname.toLowerCase();
  const isWpLandingPage = pathnameLowerCase === '/wordpressdotcom';

  return (
    <StyledWrapper>
      <SignInNavLink
        isActive={pathnameLowerCase === '/login'}
        to="/login"
        href=""
        className=""
        isDownloadLink={false}
        onClick={() => {
          clickedNavLinkGoogleAnalytics('Log In');
        }}
      >
        {t(
          'PublicWebsiteNavFooter.SignIn',
          'Sign in',
          'Link to "Sign in" web page'
        )}
      </SignInNavLink>
      <SignUpNavLink
        to={isWpLandingPage ? '/signup?ref=wp' : '/signup'}
        isDownloadLink={false}
        onClick={() => {
          clickSignupButton();
          clickedNavLinkGoogleAnalytics('Sign Up');
          if (isWpLandingPage) {
            events.clickWordPressSignUpCTA('nav');
          }
        }}
      >
        {t(
          'PublicWebsiteNavFooter.SignUp',
          'Sign up',
          'Button to "Sign up" web page'
        )}
      </SignUpNavLink>
    </StyledWrapper>
  );
};
